import { useState } from 'react';
import axios from 'axios';

const DURATIONS = ['1h', '6h', '12h', '24h', '48h', '7d', '30d'];

export default function BanModal({ onClose, onDone }) {
  const [ip, setIp] = useState('');
  const [duration, setDuration] = useState('24h');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!ip.trim()) { setError('IP obligatoire'); return; }
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/decisions/ban', {
        ip: ip.trim(),
        duration,
        reason: reason.trim() || 'Ban manuel',
      });
      onDone();
    } catch (e) {
      setError(e.response?.data?.detail || 'Erreur serveur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay onClose={onClose}>
      <h2 style={{ fontWeight:800, fontSize:'1.3rem', marginBottom:'1.5rem' }}>Bannir une IP</h2>

      <div style={{ display:'flex', flexDirection:'column', gap:'1rem', marginBottom:'1.5rem' }}>
        <Field label="Adresse IP *">
          <input
            autoFocus
            value={ip}
            onChange={e => setIp(e.target.value)}
            placeholder="ex: 1.2.3.4"
            style={inputStyle}
          />
        </Field>

        <Field label="Durée">
          <div style={{ display:'flex', gap:'0.5rem', flexWrap:'wrap' }}>
            {DURATIONS.map(d => (
              <button key={d} onClick={() => setDuration(d)} style={{
                background: duration === d ? 'var(--accent)' : 'var(--bg3)',
                color: duration === d ? '#fff' : 'var(--muted)',
                border: `1px solid ${duration === d ? 'var(--accent)' : 'var(--border)'}`,
                borderRadius:'var(--radius)',
                padding:'0.4rem 0.8rem',
                fontFamily:'var(--font-mono)',
                fontSize:'0.82rem',
                cursor:'pointer',
                transition:'all 0.1s',
              }}>{d}</button>
            ))}
          </div>
        </Field>

        <Field label="Raison">
          <input
            value={reason}
            onChange={e => setReason(e.target.value)}
            placeholder="Ban manuel support"
            style={inputStyle}
          />
        </Field>
      </div>

      {error && <div style={{ color:'var(--accent)', fontFamily:'var(--font-mono)', fontSize:'0.8rem', marginBottom:'1rem' }}>{error}</div>}

      <div style={{ display:'flex', gap:'0.75rem', justifyContent:'flex-end' }}>
        <button onClick={onClose} style={btnSecondary}>Annuler</button>
        <button onClick={handleSubmit} disabled={loading} style={{ ...btnPrimary, background:'var(--accent)' }}>
          {loading ? '…' : '🚫 Bannir'}
        </button>
      </div>
    </Overlay>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label style={{ display:'block', fontFamily:'var(--font-mono)', fontSize:'0.72rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:'0.4rem' }}>{label}</label>
      {children}
    </div>
  );
}

const inputStyle = {
  width:'100%', background:'var(--bg3)', border:'1px solid var(--border)',
  borderRadius:'var(--radius)', padding:'0.65rem 0.8rem',
  color:'var(--text)', fontFamily:'var(--font-mono)', fontSize:'0.85rem', outline:'none',
};

const btnPrimary = {
  color:'#fff', border:'none', borderRadius:'var(--radius)',
  padding:'0.65rem 1.3rem', fontFamily:'var(--font-ui)',
  fontWeight:700, fontSize:'0.85rem', cursor:'pointer',
};
const btnSecondary = {
  background:'transparent', color:'var(--muted)',
  border:'1px solid var(--border)', borderRadius:'var(--radius)',
  padding:'0.65rem 1.3rem', fontFamily:'var(--font-ui)',
  fontWeight:600, fontSize:'0.85rem', cursor:'pointer',
};

function Overlay({ children, onClose }) {
  return (
    <div onClick={onClose} style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,0.7)',
      display:'flex', alignItems:'center', justifyContent:'center', zIndex:100,
      backdropFilter:'blur(4px)',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background:'var(--bg2)', border:'1px solid var(--border)',
        borderRadius:'12px', padding:'2rem', width:'100%', maxWidth:'460px',
        margin:'1rem', boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
      }}>
        {children}
      </div>
    </div>
  );
}
